import Button from "@material-ui/core/Button";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogTitle from "@material-ui/core/DialogTitle";
import { TextField, Typography } from "@material-ui/core";
import { ControlledSelect } from "./controlledSelect";
import { useEffect, useState } from "react";

export default function CreateDealershipDialog({
    open,
    handleClose,
    data,
    onChange,
    handleFormSubmit,
    constantsData,
    licenseNumArr,
    licenseStateAddressesMap,
    dealers,
    statesList,
    country
}) {
    const licensedOption = [
        {
            value: false,
            label: "Unlicensed",
        },
        {
            value: true,
            label: "Licensed",
        },
    ];
    const [licensedState, setLicensedState] = useState(false);
    const [isClosestDeliveryLocation, setIsClosestDeliveryLocation] =
        useState(false);
    const { remittanceResponsibility, leaseTaxesPaid, leaseTaxesRemitted } = constantsData;

    const handleLicensedChange = (event) => {
        onChange(event);
        setLicensedState(event.target.value);
    };

    const handleLicenseNoChange = (event) => {
        let isValidLicense = true;
        licenseNumArr.map((item) => {
            if (item.value === event.target.value) {
                isValidLicense = false;
                data.License.hasError = true;
            }
        });
        if (isValidLicense) {
            data.License.hasError = false;
            onChange(event);
        } else {
            alert("License number should be unique");
        }
    };

    const handleLicenseChange = (event) => {
        onChange(event);
        const licensedStateDetails = licenseStateAddressesMap.get(
            event.target.value,
        );
        if (licensedStateDetails) {
            data.Address.value = licensedStateDetails.Address;
            data.City.value = licensedStateDetails.City;
            data.Zip.value = licensedStateDetails.Zip;
        }
    };

    useEffect(() => {
        setIsClosestDeliveryLocation(
            dealers?.filter((dealer) => dealer.state === data.State.value)
                .length > 0,
        );
    }, [data, dealers]);

    return (
        <>
            <div>
                <Dialog open={open} onClose={handleClose}>
                    <DialogTitle id="dealership-dialog-title">
                        Add Dealer
                    </DialogTitle>
                    <DialogContent>
                        <Typography variant="subtitle1" component="p">
                            Please fill out the dealer information below and
                            submit.
                        </Typography>
                        <div
                            style={{ marginBottom: "5px", display: "block" }}
                        ></div>
                        <form onSubmit={handleFormSubmit}>
                            <ControlledSelect
                                id="State"
                                label="Select State*"
                                value=""
                                options={statesList?.map((option) => ({
                                    value: option.stateProvinceCode,
                                    label: `${option.stateProvinceName} - ${option.stateProvinceCode}`,
                                }))}
                                onChange={onChange}
                                hasError={data.State.hasError}
                                includeAllFlag="false"
                            />
                            {country === "US" && (
                                <>
                                    <ControlledSelect
                                        id="Licensed"
                                        label="Licensed*"
                                        value=""
                                        options={licensedOption}
                                        onChange={handleLicensedChange}
                                        hasError={data.Licensed.hasError}
                                        includeAllFlag="false"
                                    />
                                    {licensedState ? (
                                        <>
                                            <TextField
                                                type="text"
                                                id="License"
                                                value={data.License.value}
                                                onChange={handleLicenseNoChange}
                                                placeholder="Enter License*"
                                                label="License"
                                                variant="outlined"
                                                margin="dense"
                                                fullWidth
                                                required={true}
                                            />
                                        </>
                                    ) : (
                                        <>
                                            <ControlledSelect
                                                id="License"
                                                label="License*"
                                                value={data.License.value}
                                                options={licenseNumArr}
                                                onChange={handleLicenseChange}
                                                hasError={data.License.hasError}
                                                includeAllFlag="false"
                                            />
                                        </>
                                    )}
                                    {isClosestDeliveryLocation && (
                                        <TextField
                                            type="text"
                                            id="closestDeliveryLocation"
                                            value={data.closestDeliveryLocation.value}
                                            onChange={(e) => onChange(e)}
                                            placeholder={
                                                "Enter Closest Delivery Location"
                                            }
                                            label="Closest Delivery Location"
                                            variant="outlined"
                                            margin="dense"
                                            fullWidth
                                            required={true}
                                        />
                                    )}
                                    <TextField
                                        type="text"
                                        id="Address"
                                        value={data.Address.value}
                                        onChange={(e) => onChange(e)}
                                        placeholder={
                                            licensedState
                                                ? "Enter Address*"
                                                : "Enter Address"
                                        }
                                        label="Address"
                                        variant="outlined"
                                        margin="dense"
                                        fullWidth
                                        disabled={!licensedState}
                                        required={licensedState}
                                    />
                                    <TextField
                                        type="text"
                                        id="City"
                                        value={data.City.value}
                                        onChange={(e) => onChange(e)}
                                        placeholder={
                                            licensedState
                                                ? "Enter City*"
                                                : "Enter City"
                                        }
                                        label="City"
                                        variant="outlined"
                                        margin="dense"
                                        fullWidth
                                        disabled={!licensedState}
                                        required={licensedState}
                                    />
                                    <TextField
                                        type="text"
                                        id="Zip"
                                        value={data.Zip.value}
                                        onChange={(e) => onChange(e)}
                                        placeholder={
                                            licensedState
                                                ? "Enter Zip*"
                                                : "Enter Zip"
                                        }
                                        label="Zip"
                                        variant="outlined"
                                        margin="dense"
                                        fullWidth
                                        disabled={!licensedState}
                                        required={licensedState}
                                    />
                                </>
                            )}

                            {country === "CA" && (
                                <>
                                    <TextField
                                        type="text"
                                        id="PdiLocation"
                                        value={data.PdiLocation.value}
                                        onChange={(e) => onChange(e)}
                                        placeholder={"Enter PDI Location*"}
                                        label="PDI Location"
                                        variant="outlined"
                                        margin="dense"
                                        fullWidth
                                        required={true}
                                    />
                                    <TextField
                                        type="text"
                                        id="ID"
                                        value={data.ID.value}
                                        onChange={(e) => onChange(e)}
                                        placeholder={"Enter ID*"}
                                        label="ID"
                                        variant="outlined"
                                        margin="dense"
                                        fullWidth
                                        required={true}
                                    />
                                    <TextField
                                        type="text"
                                        id="Address"
                                        value={data.Address.value}
                                        onChange={(e) => onChange(e)}
                                        placeholder={"Enter Address"}
                                        label="Address"
                                        variant="outlined"
                                        margin="dense"
                                        fullWidth
                                        required={true}
                                    />
                                    <TextField
                                        type="text"
                                        id="City"
                                        value={data.City.value}
                                        onChange={(e) => onChange(e)}
                                        placeholder={"Enter City"}
                                        label="City"
                                        variant="outlined"
                                        margin="dense"
                                        fullWidth
                                        required={true}
                                    />
                                    <TextField
                                        type="text"
                                        id="Zip"
                                        value={data.Zip.value}
                                        onChange={(e) => onChange(e)}
                                        placeholder={"Enter Zip"}
                                        label="Zip"
                                        variant="outlined"
                                        margin="dense"
                                        fullWidth
                                        required={true}
                                    />
                                </>
                            )}

                            <TextField
                                type="text"
                                id="Name.firstName"
                                value={data["Name.firstName"].value}
                                onChange={(e) => onChange(e)}
                                placeholder={"Enter First Name*"}
                                label="First Name"
                                variant="outlined"
                                margin="dense"
                                fullWidth
                                required={true}
                            />
                            <TextField
                                type="text"
                                id="Name.MiddleName"
                                value={data["Name.MiddleName"].value}
                                onChange={(e) => onChange(e)}
                                placeholder={"Enter Middle Name*"}
                                label="Middle Name"
                                variant="outlined"
                                margin="dense"
                                fullWidth
                                required={true}
                            />
                            <TextField
                                type="text"
                                id="Name.LastName"
                                value={data["Name.LastName"].value}
                                onChange={(e) => onChange(e)}
                                placeholder={"Enter Last Name*"}
                                label="Last Name"
                                variant="outlined"
                                margin="dense"
                                fullWidth
                                required={true}
                            />
                            <ControlledSelect
                                id="remittanceResponsibility"
                                label="Remittance Responsibility*"
                                value={data.remittanceResponsibility.value}
                                options={remittanceResponsibility}
                                onChange={onChange}
                                hasError={
                                    data.remittanceResponsibility.hasError
                                }
                                includeAllFlag="false"
                            />
                            {country === "US" && (
                                <ControlledSelect
                                    id="leaseTaxesPaid"
                                    label="Lease Taxes Paid*"
                                    value={data.leaseTaxesPaid.value}
                                    options={leaseTaxesPaid}
                                    onChange={onChange}
                                    hasError={data.leaseTaxesPaid.hasError}
                                    includeAllFlag="false"
                                />
                            )}
                            {country === "US" && (
                                <ControlledSelect
                                    id="leaseTaxesRemitted"
                                    label="Lease Taxes Remitted*"
                                    value={data.leaseTaxesRemited?.value}
                                    options={leaseTaxesRemitted}
                                    onChange={onChange}
                                    hasError={data.leaseTaxesRemitted?.hasError}
                                    includeAllFlag="false"
                                />
                            )}

                            <DialogActions>
                                <Button
                                    onClick={handleClose}
                                    color="secondary"
                                    variant="outlined"
                                >
                                    Cancel
                                </Button>
                                <Button
                                    type="submit"
                                    color="primary"
                                    variant="contained"
                                >
                                    Submit
                                </Button>
                            </DialogActions>
                        </form>
                    </DialogContent>
                </Dialog>
            </div>
        </>
    );
}
